import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id F49668FC-6B0F-43E9-BB4E-044C3C9229AA
 * name square-circle
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/square-circle.svg
 * tags
 * - Food / Drink 
 */
export const SquareCircleIcon = createSvgIcon(<><path d="M20 4V20H4V4H20M22 2H2V22H22V2M12 6C8.69 6 6 8.69 6 12S8.69 18 12 18 18 15.31 18 12 15.31 6 12 6Z" /></>, 'SquareCircleIcon');
export default SquareCircleIcon